import { Icon, IconProps } from "@chakra-ui/react";

const PaperclipIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.9758 3.98585C14.1622 3.17225 12.8431 3.17225 12.0295 3.98585L4.5165 11.4989C3.13339 12.882 3.13339 15.1244 4.5165 16.5075C5.8996 17.8906 8.14206 17.8906 9.52517 16.5075L17.0382 8.99452C17.3636 8.66908 17.8913 8.66908 18.2167 8.99452C18.5421 9.31996 18.5421 9.84759 18.2167 10.173L10.7037 17.686C8.6697 19.72 5.37197 19.72 3.33799 17.686C1.304 15.6521 1.304 12.3543 3.33799 10.3203L10.851 2.80733C12.3155 1.34287 14.6898 1.34287 16.1543 2.80733C17.6188 4.2718 17.6188 6.64617 16.1543 8.11063L8.93591 15.329C8.04096 16.224 6.58996 16.224 5.69501 15.329C4.80006 14.4341 4.80006 12.9831 5.69501 12.0881L12.0295 5.75361C12.3549 5.42818 12.8826 5.42818 13.208 5.75361C13.5335 6.07905 13.5335 6.60669 13.208 6.93212L6.87352 13.2666C6.62944 13.5107 6.62944 13.9064 6.87352 14.1505C7.1176 14.3946 7.51333 14.3946 7.7574 14.1505L14.9758 6.93212C15.7894 6.11853 15.7894 4.79944 14.9758 3.98585Z"
				fill="currentColor"
			/>
		</Icon>
	);
};

export default PaperclipIcon;
